/* PAYWALL */
const paywallConfigurator = {
    link: {
        vetrina: {
            mobile: 'https://abbonamenti.corriere.it/login/?OfferId=OFF-00123774pwcmp=vetrinafreemium'
        },
        manine: {
            ABB_mobile: 'https://abbonamenti.corriere.it/login/?OfferId=OFF-00123775',
            SHOP_mobile: 'https://www.corriere.it/economia/offerta-abbonamento/?intcmp=EconomiaManine_other_290319_corriere_ss_other'
        }
    },
    html: {
        manine: {
            mobile: '<p class="small">Corriere.it senza limiti </p> <p class="big"><strong>1&euro;</strong> al mese</p>'
        }
    }
};



window.manina_showed = false;


window.__PWL = function(pwl_obj) {

    var __static;
    if(typeof PWL_vertical !== "undefined" && PWL_vertical) $("head").append("<link rel='stylesheet' href='//css2.corriereobjects.it/includes2013/LIBS/css/vendor/_paywall-font.css'>");
    $("head").append("<link rel='stylesheet' href='//css2.corriereobjects.it/includes2013/LIBS/css/paywall.css'>");

    /* CONFIGURAZIONI */
    //se settato a TRUE il paywall non verrà  inizializzato
this.darkmode = false;

// oggetto di CONFIGURAZIONI VETRINE per estendere la view

var __Hosts = {
    current : "",
    self : location.hostname,
    paywall : "//shop-cplus.corriere.it",
    offerte : "//shop-cplus.corriere.it/offering",
    bacheca : "//cplus.corriere.it/bacheca",
    bachecaServizi : "//cplus.corriere.it/bacheca#servizi",
    corriere : "//www.corriere.it/",
    jumpLogin : "//www.corriere.it/?rcsconnect=6&contentPath="
};

var _ConfVetrine = {
    sezioni: [],
    cid: ["175600","175607","175611","175674","175684","175686","177130","177267","180148","182834","182250","184777","184167","185955","185891","185923","187204","188168","188195","188071","187822","187828","188397","188399","188394","190360","188254","191771","191772","188794","188797","194336","196255","196840","196843","197638","197585","197631","199737","201960", "201963", "201962","203383","202371","205321","208340","208420","210874","210886","211895","211894","211751","213745","213881","213894","214801","214880","219672","228548","228647", "232845","235320","235375","235359","238025","240771","240768","249596","249599","249591","249594","249593","252437","252438","252512","252513","253531","253532","253495","253535", "253536", "253529", "254971","255065", "255067", "255069","255001", "255071", "255073", "255075", "255077","255068","255000" ,"253538" ,"255070" ,"255079","255011","255062", "255012", "255013", "255063", "268462", "268441", "268437","273973"],
    customView : null,
    path: "/includes2013/SSI/_templates/_modules/paywall/vetrine", ////xml.corriereobjects.it
    showOnLoad : (tipologia !== "fotogallery"),
    scrollToView : true,
    done : function($el){
        $el.find(".rim").text(this.data.credit);
        $el.find(".quota").text(this.data.quota);
        var _vt = (this.type == "default") ? "freemium" : this.type;
        __static.appendParamsToA.call($el.find("a[href]").not("[href^=#]"),"pwcmp","vetrina"+_vt);
        __static.appendParamsToA.call($el.find(".cta-offerta"),"RedirectUrl",this.data.origin);
        __static.appendParamsToA.call($el.find(".cta-offerta"),"tr",location.href);
    },
    type: {
        "default": {
            elements: {},
            callback: function($el) {
                this.data.offerta = "dayTrial";
            }
        },
        vas: {
            elements: {},
            vetrina : "vas",
            callback: function($el) {}
        },
        postwall: {
            elements: {},
            callback: function($el) {
                this.data.offerta = "dayTrial";
            }
        },
        premium: {
            elements: {},
            vetrina : "premium",
            callback: function($el){}
        }
    }
};

// oggetto CONFIGURAZIONI MANINE per estendere la view
var _ConfManine = {
    sezioni: [],
    cid: [],
    path: "/includes2013/SSI/_templates/_modules/paywall/manine", ////xml.corriereobjects.it
    done : function($el){
        //inserisco il numero di crediti rimasto e usato nel template
        $el.find(".rim").text(this.data.credit);
        $el.find(".quota").text(this.data.quota);

       var pwcmpManina = "manina";
        /*if($el.find(".linkshop").length){
            pwcmpManina = "shopmanina";
        }
        if($el.find(".linkabb").length){
            pwcmpManina = "abbomanina";
        }*/

        __static.appendParamsToA.call($el.find(".cta-offerta"),"pwcmp", pwcmpManina+this.data.credit);
        __static.appendParamsToA.call($el.find(".linkAbbonamento"),"pwcmp", pwcmpManina+this.data.credit);

        if(__static.device == "mobile") if($("#multibar").length < 1) $el.addClass("noMultimbar");
    },
    type: {
        VAS: {
            // IN USO: vetrina HP mypaywall - 16 crediti
            elements: {
                link: __Hosts.paywall + "/manina16",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                mobileClosed: "Abbonati a 0,99&euro;",
                html: "Abbonati a <small>0,99&euro;</small> per avere<br/><small>accesso illimitato</small> al sito."
            },
            surce : false,
            callback : function($el){
                 setTimeout(function(){
                    if(__static.device == "mobile") {
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00116900&OfferVersion=1');
                    }else{
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00110890&OfferVersion=1');
                    }
                 },200)
            }
        },
        esclusivi: {
            //bacheca - 8 crediti
            elements: {
                link: __Hosts.bacheca,
                type : "esclusivi",
                cta: "Scopri C+",
                html: "Ogni mattina leggi PrimaOra a cura <br />delle firme di Corriere. In esclusiva per te!"
            },
            surce : false
        },
        conteggio: {
            //non configurata
            elements: {
                link: __Hosts.paywall + "/manina8",
                type : "conteggio",
                cta: "Scopri C+",
                html: "Questo mese hai letto <strong class='n_crediti'><span class='rim'></span> dei <span class='quota'>20</span></strong> contenuti gratuiti"
            },
            surce : false,
            callback : function($el){
                $el.find(".pwl_clame").text("Entra in C+ per avere accesso illimitato");
            }
        },
        VAS2: {
            //bacheca servizi - 13 crediti
            elements: {
                link: __Hosts.bacheca,
                type : "VAS",
                cta: "SOLO 0,99&euro;",
                html: "Questo mese hai ancora <strong>7 contenuti</strong> che puoi leggere <strong>gratuitamente</strong>!"
            },
            surce : false,
            callback : function($el){
                $el.find(".pwl_clame").text("Entra in C+ per avere accesso illimitato");
                 setTimeout(function(){
                    if(__static.device == "mobile") {
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00116900&OfferVersion=1');
                    }else{
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00110890&OfferVersion=1');
                    }
                 },200)
            }
        },
        /*conteggio6: {
            //bacheca servizi - 6 crediti tablet
            elements: {
                link: __Hosts.bacheca,
                type : "VAS",
                cta: "SOLO 0,99&euro;",
                html: "Questo mese hai ancora <strong>4 contenuti</strong> che puoi leggere <strong>gratuitamente</strong>!"
            },
            surce : false,
            callback : function($el){
                $el.find(".pwl_clame").text("Entra in C+ per avere accesso illimitato");
                 setTimeout(function(){
                    if(__static.device == "mobile") {
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00116900&OfferVersion=1');
                    }else{
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00110890&OfferVersion=1');
                    }
                 },200)
            }
        },*/
        conteggio14 : {
            //vetrina HP mypaywall - 14 crediti
            elements: {
                link: __Hosts.paywall + "/manina14",
                type : "conteggio",
                cta: "Scopri C+",
                html: "Questo mese hai letto <strong class='n_crediti'><span class='rim'></span> dei <span class='quota'>20</span></strong> contenuti gratuiti"
            },
            surce : false,
            callback : function($el){
                $el.find(".pwl_clame").text("Entra in C+ per avere accesso illimitato");
            }
        },
        VAS3: {
            // IN USO: vetrina HP mypaywall - 18 crediti
            elements: {
                link: __Hosts.paywall + "/manina18",
                type : "VAS",
                cta: "SOLO 0,99&euro;",
                html: "Abbonati a <small>0,99&euro;</small> per avere<br/><small>accesso illimitato</small> al sito."
            },
            surce : false,
            callback : function($el){
                 setTimeout(function(){
                    if(__static.device == "mobile") {
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00116900&OfferVersion=1');
                    }else{
                        $el.find(".cta-offerta").attr('href','//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00110890&OfferVersion=1');
                    }
                 },200)
            }
        },
        VAS4: {
            // IN USO: vetrina HP mypaywall - 6 crediti - mobile
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: "Naviga il sito illimitatamente a <span style='font-weight: bold;'>soli 0,50&euro; a settimana.</span>"
            },
            surce : false,
              callback : function($el){
               $el.find(".pwl_clame").html("Aderisci <strong class='n_crediti'>all'offerta speciale</strong> di questo mese");
            }
        },
        conteggio4: {
            // IN USO: vetrina HP mypaywall - 6 crediti - tablet
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
                //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>04 contenuti gratuiti</strong> questo mese");
            }
        },
        VAS5: {
            // IN USO: vetrina HP mypaywall - 5 crediti
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00118113&OfferVersion=1",
                type : "VAS",
                cta: "Abbonati",
                html: "Leggi Corriere senza limiti: <br><strong>basta un click</strong>!"
            },
            surce : false,
              callback : function($el){
                $el.find(".pwl_clame").text("Registrati a C+ e leggi per un giorno");
            }
        },
         conteggio2: {
            // IN USO: vetrina HP mypaywall - 13 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119015&OfferVersion=1",
                type : "conteggio",
                cta: "Scopri di pi&ugrave;",
                html: "<strong class='n_crediti'>Offerta speciale di questo mese:</strong> Corriere Digital Edition e sito illimitato a <strong class='n_crediti'>soli 3 &euro; al mese per 6 mesi.</strong>"
            },
            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>06 contenuti gratuiti</strong> questo mese");
            }
        },
        VAS6: {
            // IN USO: vetrina HP mypaywall - 4 crediti - mobile
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: "Naviga il sito illimitatamente a <span style='font-weight: bold;'>soli 0,50&euro; a settimana.</span>"
            },
            surce : false,
              callback : function($el){
                $el.find(".pwl_clame").html("Aderisci <strong class='n_crediti'>all'offerta speciale</strong> di questo mese");
            }
        },
        VAS7: {
            // IN USO: vetrina HP mypaywall - 3 crediti - mobile
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00118906&OfferVersion=1",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: "Naviga il sito illimitatamente a <span style='font-weight: bold;'>soli 0,50&euro; a settimana.</span>"
            },
            surce : false,
              callback : function($el){
                $el.find(".pwl_clame").html("Aderisci <strong class='n_crediti'>all'offerta speciale</strong> di questo mese");
            }
        },
        VAS8: {
            // IN USO: vetrina HP mypaywall - 2 crediti - mobile
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: "Naviga il sito illimitatamente a <span style='font-weight: bold;'>soli 0,50&euro; a settimana.</span>"
            },
            surce : false,
              callback : function($el){
                $el.find(".pwl_clame").html("Aderisci <strong class='n_crediti'>all'offerta speciale</strong> di questo mese");
            }
        },
        conteggio6: {
            // IN USO: vetrina HP mypaywall - 4 crediti - tablet
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
                //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>07 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio7: {
            // IN USO: vetrina HP mypaywall - 3 crediti - tablet
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
                //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>07 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio8: {
            // IN USO: vetrina HP mypaywall - 2 crediti - tablet
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
                //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>07 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio7desk: {
            // IN USO: vetrina HP mypaywall - 8 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>08 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio5: {
            // IN USO: vetrina HP mypaywall - 10 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>08 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio9desk: {
            // IN USO: vetrina HP mypaywall - 9 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>08 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio11desk: {
            // IN USO: vetrina HP mypaywall - 11 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>08 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio12: {
            // IN USO: vetrina HP mypaywall - 12 crediti - desktop
             elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119013&OfferVersion=1",
                type : "conteggio",
                cta: "Scopri di pi&ugrave;",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente. <strong class='n_crediti'>soli 0,50&euro; a settimana.</strong>"
            },

            surce : false,
              callback : function($el){
              //$el.find(".pwl_clame").html("Hai ancora <strong class='n_crediti'>08 contenuti gratuiti</strong> questo mese");
            }
        },
        conteggio13desk: {
            // IN USO: vetrina HP mypaywall - 2 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "Aderisci <strong class='n_crediti'>all'offerta speciale di questo mese</strong> e naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
            }
        },
        VAS10: {
            // IN USO: vetrina HP mypaywall - 7 crediti - mobile
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: "Naviga il sito illimitatamente a <span style='font-weight: bold;'>soli 0,50&euro; a settimana.</span>"
            },
            surce : false,
              callback : function($el){
                $el.find(".pwl_clame").html("Questo &egrave; il tuo ultimo <strong class='n_crediti'>contenuto gratuito.</strong>");
            }
        },
        conteggio10: {
            // IN USO: vetrina HP mypaywall - 10 crediti - tablet
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type :"conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "<strong class='n_crediti'>Questo &egrave; il tuo ultimo contenuto gratuito.</strong> Naviga il sito illimitatamente."
            },
            surce : false,
              callback : function($el){
                // $el.find(".pwl_clame").html("Questo Ã¨ il tuo ultimo <strong class='n_crediti'>contenuto gratuito</strong> del mese.");
            }
        },
        wall: {
            //bacheca servisi - 19 crediti
            elements: {
                link: __Hosts.paywall + "/manina19",
                type : "wall",
                cta: "Scopri C+",
                html: "Corriere della Sera non cambia, cresce <small>Contenuti e vantaggi esclusivi solo per te!</small>"
            },
            surce : false
        },

        MANINAXMAS2018_X: {
            // IN USO: mobile
            elements: {
                link: "PLACEHOLDER",
                type : "VAS",
                cta: "Scopri di pi&ugrave;",
                html: paywallConfigurator.html.manine.mobile
            },
            surce : false,
            callback : function($el){
                var linkAbb = paywallConfigurator.link.manine.ABB_mobile;
                var linkShop = paywallConfigurator.link.manine.SHOP_mobile;
                $el.find(".pwl_clame").html("<span>Offerta speciale</span><div class='alreadySubscribe'><a href='javascript:accediLinkPop();'>Sei gi&agrave; abbonato? Fai Login >></a></div>");
                /*var rnd_payw = Math.floor(Math.random() * 10); 
                if( rnd_payw == 0 ){
                    $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkShop));
                    $el.find(".cta-offerta").addClass('linkshop');
                }else{
                    $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkAbb));
                    $el.find(".cta-offerta").addClass('linkabb');
                }*/
                $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkAbb));
                $el.find(".linkAbbonamento").attr("href", $el.find(".cta-offerta").attr("href"));
                $el.find(".cta-offerta").addClass('linkabb');
                
            }
        },
        MANINAXMAS2018: {
            // IN USO: desktop - tablet
            elements: {
                link: "PLACEHOLDER",
                type : "conteggio",
                cta: "Scopri di pi&ugrave;",
                html: "Corriere.it senza limiti, <strong>1&euro;</strong> al mese"
            },
            surce : false,
              callback : function($el){
                var linkAbb = "https://abbonamenti.corriere.it/login/?OfferId=OFF-00122921";
                var linkShop = "https://www.corriere.it/economia/offerta-abbonamento/?intcmp=EconomiaManine_other_290319_corriere_ss_other";
                /*var rnd_payw = Math.floor(Math.random() * 10); 
                //console.log("math random ------> ", rnd_payw);
                if( rnd_payw == 0 ){
                    $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkShop));
                    $el.find(".cta-offerta").addClass('linkshop');
                }else {
                    $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkAbb));
                    $el.find(".cta-offerta").addClass('linkabb');
                }*/
                $el.find(".cta-offerta").attr("href", $el.find(".cta-offerta").attr("href").replace("PLACEHOLDER",linkAbb));
                $el.find(".linkAbbonamento").attr("href", $el.find(".cta-offerta").attr("href"));
                $el.find(".cta-offerta").addClass('linkabb'); 
            }
        },        
        last: {
            // IN USO: bacheca servizi - 20 crediti - desktop
            elements: {
                link: "//shop-cplus.corriere.it/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119393&OfferVersion=1",
                type : "conteggio",
                cta: "Abbonati <span>a soli 0,50&euro; a settimana.</span>",
                html: "<strong class='n_crediti'>Questo &egrave; il tuo ultimo contenuto gratuito.</strong> Naviga il sito illimitatamente."

            },
            surce : false,
            callback : function($el){
                //$el.find(".pwl_clame").text("Entra in C+ per avere accesso illimitato");
            }

        },
        // doubleOptin : {
        //     elements: {
        //         type : "doubleOptin",
        //         cta: "Scopri C+",
        //         link: "#!Link_alla_mail",
        //         html: "<p>Ti ricordiamo che non hai ancora confermato la tua mail.</p>"
        //     },
        //     surce : false
        // },
        doubleOptin: false, //mai sviluppata in definitiva
        none: false
    }
};

// oggetto di CONFITURAZIONE DELL'OFFERTA
var _Offerte = {
    none: false,
    dayTrial: {
        ifTrue: function(view) {
            return (__static.getCookie("OF00000") == "");
        },
        idOfferta: "OF00000",
        classes: "",
        offerta: "Prova gratis corriere naviga+<br />e leggi il sito senza limiti per un giorno,<br/>basta un click.",
        dettagli: "Tutti i contenuti del sito di Corriere della Sera gratis per un giorno. Registrati!",
        //cta: __Hosts.paywall + "/is-bin/INTERSHOP.enfinity/WFS/RCS-RCS_Membership-Site/it_IT/-/EUR/ViewRequisition-Buy?OfferId=OFF-00119124&OfferVersion=1",
        cta: "//abbonamenti.corriere.it/login/?OfferId=OFF-00121353_1&intcmp=OverlayPostWallfreetrial_other__corriere_other_other",
        cta_no: "#",
        testo_cta: "Prova",
        testo_nocta: "No grazie",
        beforeRender: function($el,view) {
            //this.cta += encodeURIComponent(__static.data.origin);
        },
        callback: function($el,view) {
            __static.setCookie("OF00000", 1, 1);
            //tracciamento apertura freetrial
            __static.track("TrialOffer");
            __static.track("CriteoOffertaFreeTrial");
        }
    }
};

// classe rappresentante l'istanza di gestione dei dati del paywall
var _Data = function(o) {
    this.reason = null;
    this.cat = 0;
    this.cid = null;
    this.login = false;
    this.credit = null;
    this.quota =  10;
    this.sezione = null;
    this.offerta = false;
    this.jumpLogin = false;
    this.mPay = (__static.device != "mobile") ? 0 : 1;
    this.checkView = function(data){
        //se free non renderizzo niente.
        if(data.cat === 0 && data.methAnt != 1){
            __static.view = {
                run : function(){
                    __static.log("L'elemento sembra essere Free o siamo in una preview senza variable Methode (vedi sotto se uguale a 0)",PWL_methAnt);
                }
            }
            return false;
        }
        return true;
    };
    this.referrer = "";
    this.status = 0;
    $.extend(true, this, o);
}

// classe rappresentante l'istanza delle configurazioni delle tipologie di vista
var _viewConf = function(obj_conf){
    this.elements = {};
    this.surce = undefined;
    this.callback = undefined;
    this.endpoint = true;
    this.CTAlogin = true;
    this.displayCallback = undefined;
    $.extend(this,obj_conf);
}

    /* CORE */
        //author Simone Luise

    this.query = {};
    this.view;
    this.Cookie = {};
    this.data = {};

    //variabile per i tracciamenti (valorizzata con il nome della view se in pagina viene renderizzata)
    this.renderView = false;

    //metodo che gestice il reperimento dei dati necessari al paywall
    this.getData = function() {

        var O = {};
        this.query = this.parseQuery();
        O.methAnt = this.isAnteprima();
        O.status = this.userStatus();
        O.reason = this.getReason();
        var cR = this.getCredit();
        O.credit = cR[0];
        O.quota = cR[1];
        O.sezione = this.getSezione();
        O.cat = this.getCat();
        O.cid = this.getCid();
        O.referrer = this.getReferrer();
        this.isMobile();
        O.origin = this.getOrigin();
        if(typeof this.query["mpay"] !== "undefined") O.mPay = this.query["mpay"];
        if(typeof this.query["PWL_debug"] !== "undefined") this.debug = true;

        if(O.sezione == "blog") O.jumpLogin = true;

        for (var k in O) {
            if (!O[k]) delete O[k];
        }

        this.data = new _Data(O);
    }

    // metodo di inizializzazione del paywall (reperimento dati)
    this.init = function() {

        __static = this;
        __static.hosts = __Hosts;

        this.getData();

        $.extend(true, this, pwl_obj);

        //debug
        this.getTestParams();
        this.log(this.data);

        //custom event intPWL
        this.performMiddleware("PwlInitDone",this);
    }

    // metodo pubblico che gestisce il processo di esecuzione del paywall (selezione e rendering della view)
    this.run = function() {

        if(this.darkmode){
            //se Ã¨ attivato il darkmode non inizializzo nulla e rivalorizzo la funzione di RUN della view
            this.log("DARKMODE attivo");
            this.debug = false;
            this.view = {
                run : function(){}
            };
            return;
        }

        this.checkPaywall();
        // this.runtime();

        //custom event PWLrun
        this.performMiddleware("PwlRunDone");
    }

    // metodo che gestisce il reperimento dei dati utente
    this.userStatus = function(a,b) {
        try{
            if(_apw.modules.subscribers_ac.is_subscribed()) return 3;
        }catch(e){
            __static.log("APW ERROR - Subscribers - _apw seems undefined");
        }

        a = this.getCookie("apw_auth");
        if(a == "") return 0; //unlogged
        b = this.getCookie("apw_cache");
        if(this.debug){
            this.Cookie.auth = a.split(".");
            this.Cookie.subscript = b.split(".");
        }
        if(b == "") return 1; //unauthorized
        if(new Date(a.split(".")[2]) < new Date()) return 1; //unauthorized
        if(b.split(".")[6] == "0") return 2; //unsubscrived
        return 3; //auth and sub
    }

    // ritorna 0 se non siamo su un'anteprima methode (altrimenti 1)
    this.isAnteprima = function(){
        return PWL_methAnt || 0;
    }

    // metodo che gestisce il reperimento del dato in query "reason"
    this.getReason = function() {
        return (typeof this.query.reason !== "undefined") ? this.query.reason : null;
    }

    // metodo che gestisce il reperimento del dato "credits"
    this.getCredit = function(a,q) {
        try{
            var apw = _apw.modules.anonymous_ac.get();
            a = apw.used;
            q = apw.quota;
            document.dispatchEvent(new CustomEvent('RCSPaywall:ManineReady'));
        }catch(e){
            a = 0;
            q = 20;
            __static.log("APW ERROR - Credit - _apw seems undefined");
        }
        a = parseInt(a) || null;
        q = parseInt(q) || 20;

        return [a,q];
    }

    // metodo che gestisce il reperimento della sezione normalizzandola (senza maiuscole ne spazi[= "_" ])
    this.getSezione = function(s) {
        return (typeof sezione !== "undefined") ? sezione.toLocaleLowerCase().replace(/ /g,"_") : "default";
    }

    // metodo che gestisce il reperimento del dato "cat" dalla query
    this.getCatByQuery = function(){
        return (typeof this.query.cat !== "undefined") ? parseInt(this.query.cat) : 0;
    }

    // metodo che gestisce il reperimento del dato "cid" dalla query
    this.getCidByQuery = function(){
        return (typeof this.query.cid !== "undefined") ? this.query.cid : null;
    }

    // metodo che di check sul device
    this.isMobile = function(){
        try{
           this.device = window.device;
        }catch(e){
            __static.log("Rilevazione device fallita: window.device non disponibile");
            var check = "desktop";
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = "mobile"})(navigator.userAgent||navigator.vendor||window.opera);
            this.device = check;
        }
    }

    // metodo che gestisce il reperimento del dato "cat"
    this.getCat = function(a) {
        //Cat per vetrine
        if(PWL_methAnt === 1) return this.getCatByQuery();
        try{
            //Cat per manine
            a = _apw.modules.access.get().category || 0;
        }catch(e){
            __static.log("APW ERROR - Category - _apw seems undefined");
            a = this.getCatByQuery();
        }
        return a;
    }

    // metodo che gestisce il reperimento del dato "cid"
    this.getCid = function() {
        //cid per vetrine
        if(PWL_methAnt === 1) return this.getCidByQuery();

        //cid per manine
        try{
            a = _apw.modules.access.get().content || null;
        }catch(e){
            __static.log("APW ERROR - Cid - _apw seems undefined");
            a = this.getCidByQuery();
        }
        return a;
    }

    // metodo che gestisce il reperimento del dato di origine della navigazione
    this.getReferrer = function() {
        return (typeof document.referrer === "string" && document.referrer !== "" && document.referrer.indexOf("corriere.it") >= 0 && document.referrer.indexOf("_preview.shtml") < 0) ? document.referrer : "//"+this.hosts.self;
    }

    //articolo di origine della redirect
    this.getOrigin = function(){
        //if(typeof this.query.trackingCode !== "undefined") return this.query.trackingCode;
        return (typeof this.query.origin === "undefined" || this.query.origin == "")
            ? this.getReferrer()
            : decodeURIComponent(this.query.origin);
    }

    // metodo utilizzato in fase di test per l'override manuale tramite query dei vari dati
    this.getTestParams = function(){
        if(!this.debug) return;
        if(typeof this.query.credit !== "undefined"){
            this.log("Override Credit: "+ this.data.credit +" >>> "+this.query.credit);
            this.data.credit = parseInt(this.query.credit);
        }
        if(typeof this.query.cat !== "undefined"){
            this.log("Override Category: " + this.data.cat + " >>> " + this.query.cat);
            this.data.cat = parseInt(this.query.cat);
        }
    }

    //metodo per definire il tipo di vista da caricare
    this.checkPaywall = function(d) {

        this.data.offerta = false;
        if (typeof this.data.checkView === "function") if(!this.data.checkView(this.data)) return false;
        if (this.data.methAnt == 1) {
            this.view = new this.View(Vetrina, this);
        } else if(this.data.status !== 3 && this.data.cat < 2) {
            this.view = new this.View(Manina, this);
        } else {
            __static.log("Utente Membership");
            return false;
        }
        __static.log(this.view);
        return true;
    }

    //display dei banner SASRTDM
    this.display_SASRTDM = function(option){

        if(typeof SASRTDM === "undefined" || typeof SASRTDM.show !== "function") return __static.log("l'oggetto SASRTDM non Ã¨ definito");
        var suffix = (__static.device == "mobile")?"mob":"web";
        option.id_openx_zone = OxAzonePaywall[suffix+option.id_openx_zone];
        __static.log("SASRTDM option",option);
        $.extend(SASRTDM,option);
        window.box_sas_openx = SASRTDM.show();

    }

    this.appendParamsToURL = function(url,params,value){
        var suffix = (url.indexOf("?") >= 0) ? "&" : "?";
        var url = url.split("#");
        url[1] = (typeof url[1] === "undefined")? "" : "#"+url[1];
        return url[0] + suffix + params + "=" + encodeURIComponent(value) + url[1]; //encoding url + hastag (se esiste)
    }

    //metodo che aggiunge un parametro all'url di un tag <a>
    // params Ã¨ il nome del parametro
    // value Ã¨ il valore
    // [$el] opzionale Ã¨ l'elemento a al quale aggiungere il parametro
    // this se non Ã¨ valorizzato il capo $el deve necessariamente essere l'elemento a
    this.appendParamsToA = function(params,value,$el){
        if(!($el instanceof jQuery) && !(this instanceof jQuery)) return __static.log("Impossibile appendere il parametro" + params + "ad un elemento non Jquery.");
        if(!($el instanceof jQuery)) $el = this;
        if($el.length < 1) return;
        $el.each(function(){
            if(!$el.is("a")) return __static.log($el, "MUST BE A TAG");
            var url = $(this).attr("href");
            $(this).attr("href",__static.appendParamsToURL(url,params,value));
        });
        return $el;
    }

    //metodo per popolare un template JS
    this.tmpl = function(t, o, c, k) {
        c = t.replace(/###([^#]*)###/g, function(m, a) {
            return (typeof o[a] !== "undefined") ? o[a] : "";
        });
        return $(c);
    }

    //metodo per reperire i cookie dal nome
    this.getCookie = function(n, p, m, c) {
        p = RegExp(n + "=.[^;]*");
        m = document.cookie.match(p);
        if (m) {
            c = m[0].split('=');
            return decodeURIComponent(c[1]);
        }
        return "";
    }

    //metodo per reperire settare i cookie (nome / valore)
    this.setCookie = function(n, v, ex, d) {
        d = new Date();
        d.setTime(d.getTime() + (ex * 24 * 60 * 60 * 1000));
        ex = "expires=" + d.toGMTString();
        document.cookie = n + "=" + encodeURIComponent(v) + "; " + ex + "; domain=.corriere.it; path=/";
    }

    //metodo che gestisce il caso in cui non siano abilitati i Cookie
    this.NoCookie = function(){this.log("COOKIE NON ABILITATI [!!!]")}

    //metodo che estrae la querystring e la trasforma in un oggetto (chiave / valore)
    this.parseQuery = function(ar, o, t) {
        o = {};
        ar = location.href.match(/([^?&=]*)=([^&=]*)/g);
        if (!ar) return {};
        for (var i = 0; i < ar.length; i++) {
            t = ar[i].split("=");
            o[t[0]] = t[1];
        }
        return o;
    }

    //metodo per i tracciamenti
    this.trackoverlay = function(){
        return (this.isAnteprima() && tipologia != "fotogallery")
    }

    // debug mode
    this.debug = (false && typeof console === "object") ? (function() {
        console.info("PWL :: LOG ATTIVO");
        return true;
    })() : false;

    this.version = "1.6.1";

    //log specifico del paywall
    this.log = function() {
        if (this.debug !== true) return false;
        for (var i = 0; i < arguments.length; i++) {
            console.info("{{PWL debug}} ::", arguments[i]);
        }
    }

    /* VISTE */
        //classe view
    // o - oggetto che estende la view in base al tipo di view richiesta (manina o vetrina)
    // c - contesto di richiamo della view (sempre il paywall)
    this.View = function(o, c) {

        this.name = null;
        this.id;

        this.el = "#pwl_vt";
        this.$el = $(this.el);
        this.$place;
        this.$tmpl = [];

        this.data = c.data;
        this.config;
        this.view = {};

        //metodo che restituisce l'elemento jquery al quale appendere l'html generato dalla view
        this.setPlace = function(){
            return $("body");
        };

        //metodo che restituisce la view corrente in base ad un parametro inizializzato assieme alla view
        this.setView = function() {
            return false;
        };

        //metodo richiamato per chiudere la view corrente (solitamente richiama un secodno metodo tipico della view)
        this.close = function() {
            //custom event PwlVetrinaClose
            __static.performMiddleware("PwlOnClose",{view:this,$el : this.$el});
            location.href = this.data.referrer;
        }

        //metodo casi particolari (posizionamenti differenti, override, ecc..) da implementare prima di mostrare la view
        this.cases = function() {}

        //metodo per mostrare e bindare il click sui tasti di login specifici per il paywall indicati dalla classe .pwl_login
        this.hideLogin = function(){
            if(this.data.status === 0 && this.view.CTAlogin !== false){
                var __self = this;
                if(__static.device != "mobile" || this.is === "vetrina"){
                    $(".pwl_login").css("display","block").on("click",function(e){
                        e.preventDefault();
                        //__self.close();

                        var loginRedirect = (location.href.indexOf("_preview.shtml") !== null) ? location.href.replace("_preview.shtml",".shtml") : location.href;
                        //se Ã¨ un vertical uso la login con salto su corriere
                        if(__self.data.jumpLogin) return location.href = __static.hosts.jumpLogin + encodeURIComponent(loginRedirect);
                        lcom_LoginCom("paywall");
                    });
                }
            }
        }

        //metodo che inizializza l'adv e le posizioni openx nella view
        this.displayADV = function(){

            // var option = {};
            // option.id_posizione = "SP1";

            // if(this.data.cat === 4){
            //     if(this.$el.find("#SAS_vas").length < 1) return;
            //     option.id_pagina= "VAS";
            //     option.id_contenitore = "SAS_vas";
            //     option.id_openx_zone = "_vetrinavas_sp1";
            // }else{
            //     if(this.$el.find("#SAS_vta").length < 1) return;
            //     option.id_pagina= "VTA";
            //     option.id_contenitore = "SAS_vta";
            //     option.id_openx_zone = "_vetrinaarticoli_sp1";
            // }
            // __static.display_SASRTDM(option);
        }

        //metodo contenente il comportamento di visualizzazione della view
        this.show = function() {
            this.$el.show();

            //custom event PwlAfterShow
            __static.performMiddleware("PwlAfterShow",this);
        }

        //metodo richiamato dall'esterno che gestisce il rendering dopo la chiamata al template (this.run)
        this.render = function() {
            if (this.view) this.$el = $(__static.tmpl(this.$tmpl.html(), this.view.elements));
            this.$el.appendTo(this.$place);

            //imposto l'adv
            this.displayADV();

            //callback tipologia di view
            if (typeof this.view.callback === "function") {
                this.view.callback.call(this, this.$el);
                delete this.view.callback;
            }

            //nascono la login per gli utenti loggati
            this.hideLogin();

            //eseguo il metodo per gestire i casi particolari
            this.cases.call(this);

            //callback generica view
            if (typeof this.config.done === "function") this.config.done.call(this,this.$el,this.config);

            //custom event PwlBeforeShow
            __static.performMiddleware("PwlBeforeShow",{view:this,$el : this.$el});

            //dispongo la view
            this.show();
        };

        this.setCustomOptions = function(){
            return 0;
        }

        /* ************* start AUTOMATIC VAS / VETRINE ************* */

        // metodo che gestisce la chiamata al template cercato
        this.callTemplate = function() {
            var __self = this;
            $.ajax({
                url: this.config.path + "/index.shtml",
                data: this.config.req,
                datatype: "html",
                success: function(ht) {
                    //seleziono solo la parte dell'html senza i commenti generati dal global cofing
                    __self.view.elements.html = $(ht).find("span").html();
                    //renderizzo
                    __self.render();
                },
                error: function() {
                    $("#pwl_overlay").remove();
                    __static.log("Errore nel caricamento della view:" + __self.setView());
                }
            })
        };

        // metodo che gestisce la chiamata al nuovo servizio che restituisce i dati dal CID
        this.callVasTemplate = function(){
            var __self = this,
                vt,
                __cid = this.data.cid;
            $.ajax({
                url: "//cplus.corriere.it/service-vas/vetrina/"+ __cid,
                datatype: "json",
                success: function(data) {
                    __self.config.req.cid = data.vetrinaContestuale;
                     vt = data.vetrinaContestuale;
                },
                error: function() {
                    __static.log("Errore nel caricamento della view:" + __self.setView());
                },
                complete: function(){
                    __self.callTemplate();
                }
            })
        };

        // metodo pubblico utilizzato per iniziare la renderizzazione della view dopo essere stata inizializzata
        this.run = function() {
            if (!this.type) {
                __static.log("Nessuna vista.");
                return false;
            }
            var __self = this;

            var style = (!this.config.showOnLoad) ? "display:none" : "";
            if (this.name == "Vetrina") $("body").append('<div id="pwl_overlay" style="' + style + '"><div class="loader"></div></div>');

            //controllo se il template va richiamato tramite ajax
            if (typeof this.view.surce === "undefined") {

                //setto i parametri (this.config.req) della chiamata
                this.writeRequest();

                if (this.data.cat !== 4) this.callTemplate();
            } else {
                //inserisco l'html in un contenitore
                this.view.elements.html = "<section><a class='linkAbbonamento' href='#'>" + this.view.elements.html + "</a></section>";
                //renderizzo
                this.render();
            }
        };

        // metodo che gestisce la costruzione dei dati da inviare assieme alla request del template (se necessario)
        this.writeRequest = function() {
            var vetrinaVAS;
            var __self = this;
            var __cid = __self.data.cid;

            this.config.req = {
                type : this.type,
                custom : [0,0,0],
                cid : ''
            }

            //gestisco le customizzazioni
            if(this.config.customView !== null){
                this.config.req.custom[0] = this.config.customView;
            }else{
                this.config.req.custom[0] = "0.0";
            }

            // richiedo come default la vetrina mPay a meno che venga richiesto diversamente
            if (this.is == "vetrina" && __static.device == "mobile" && this.data.mPay) this.config.req.custom[1] =  this.data.mPay;

            this.config.req.custom[2] = this.setCustomOptions();

            this.config.req.custom = this.config.req.custom.join(".");

            if(this.data.cat === 4) {
                if (typeof this.config.cid == "object" && this.data.cid !== null && $.inArray(this.data.cid, this.config.cid) >= 0) {
                    // VECCHIO GIRO
                    this.config.req.cid = this.data.cid;
                    this.callTemplate();
                } else {
                    // NUOVO GIRO
                    this.callVasTemplate();
                    return;
                }
            }
        };

        /* ************* end AUTOMATIC VAS / VETRINE ************* */

        //controller offerta
        this.getModalOfferta = function(t, o) {

            //solo utenti senza crediti
            if(this.data.credit !== this.data.quota || typeof this.data.offerta == "undefined") return false;

            var __self = this;
            t = this.data.offerta;

            //verifico che il contesto sia solidale con l'offerta
            if (typeof t === "undefinde" || !t || typeof _Offerte[t].ifTrue === "undefined" || !_Offerte[t].ifTrue.call(_Offerte[t],this)) return false;

            o = (typeof _Offerte[t] == "undefined") ? _Offerte.none : _Offerte[t];

            //verifico che ci sia un offerta relativa alla categoria
            if (o === false) return false;
            delete o.ifTrue;

            //chiamo la funzione beforeRender e poi la elimino dall'oggetto
            if(typeof o.beforeRender === "function"){
                o.beforeRender.call(o, $("#pwl_offerta"),this);
                delete o.beforeRender;
            }

            //verifico la presenza della callback la metto in cache e la elimino dall'oggetto
            var _call = function(){};
            if(typeof o.callback === "function"){
                _call = o.callback;
                delete o.callback;
            }

            var offTmpl = __static.tmpl($("#pwl_tmpl_offerta").html(), o);
            var $offElement = offTmpl.appendTo("body").filter("#pwl_offerta");

            //posiziono correttamente la finestra
            var offCss = {};
            offCss.top = (__static.device === "mobile") ? __self.$el.find(".vt-top p").offset().top - ($offElement.height() / 2) : this.offset + 200;

            //posiziono verticalmente sulla vetrina su desktop
            $offElement.css(offCss);

            var $overlays = $("#pwl_offerta,#pwl_off_overlay");
            if ($overlays.length != 2) setTimeout(function() {$overlays.fadeIn();}, 1000);
            $overlays.fadeIn();

            $("#pwl_offerta .close, #pwl_offerta .cta.no a").on("click", function(e) {
                __self.closeOfferta();
            });

            //callback
            _call.call(o, $("#pwl_offerta"),this);

            //custom event PwlOnOffertShow
            __static.performMiddleware("PwlOnOffertShow",{view:this,$el : $("#pwl_offerta")});

            return true;
        }

        //metodo per la gestione della chiusura dell'offerta
        this.closeOfferta = function() {
            location.href = this.data.referrer;
            //$("#pwl_offerta,#pwl_off_overlay").fadeOut();

            //custom event PwlOnOffertShow
            __static.performMiddleware("PwlOnOffertClose",{view:this,$el : $("#pwl_offerta")});
        }

        //metodo di inizializzazione della view (richiamato automaticamente durante la "run" del paywall)
        this.init = function() {
            if (typeof this.data.checkView !== "undefined") delete this.data.checkView;
            this.id = "VW" + new Date().getTime();
            if (this.name == null) this.name = "VIEW - " + this.id;

            //setto l'elemento in cui appendere la view
            this.$place = this.setPlace();

            this.type = this.setView();
            if (this.type && typeof this.config.type[this.type] !== "undefined" && this.config.type[this.type]){

                if(!navigator.cookieEnabled) __static.NoCookie();
                //setto le configurazioni della view specifica
                this.view = new _viewConf(this.config.type[this.type]);
                __static.renderView = this.is;

            }else{
                this.type = false;
            }

            //custom event PwlViewInit
            __static.performMiddleware("PwlViewInit",{view:this});
        }

       //estensione della classe
        $.extend(true, this, o);

        this.init();
    }

        var Vetrina = {

        name: "Vetrina",
        is: "vetrina",
        config: _ConfVetrine,

        el: "#pwl_vt",
        $el: $(this.el),
        $tmpl: $("#pwl_tmpl_vt"),

        getPlace : function(){
            return ($(".container-body-article").length > 0) ? $(".container-body-article") : $("body");
        },

        setView: function() {
            switch (this.data.cat) {
                // case 1:
                //     return "freemium";
                //     break;
                case 2:
                    return "postwall";
                    break;
                case 3:
                    return "premium";
                    break;
                case 4:
                    return "vas";
                    break;
                default:
                    return "default";
            }
        },

        openModal: function() {
            __self = this;
            this.$el = $(this.el);

            if ($("#pwl_overlay").is(":hidden")) $("#pwl_overlay").fadeIn();
            this.$el.find("#content_vetrina").fadeIn();
            this.$el.fadeIn();

            if (this.$el.is(":hidden")) this.$el.fadeIn();

            //custom event PwlAfterShow
            __static.performMiddleware("PwlAfterShow",{view:this,$el : this.$el});

            this.$el.find(".close").on("click", function(e) {
                __self.closeVetrina();
            });

            if(__static.device !== "mobile"){

                this.$el.find(".close").delay(1000).animate({
                    top: "-32px",
                    opacity : 1
                },800,function(){

                    //sposto il focus della pagina sulla vetrina
                    if(__self.config.scrollToView) $("html,body").animate({
                        scrollTop : __self.offsetScroll
                    },200);

                    __self.$el.addClass("loaded");
                    $("#pwl_overlay .loader").remove();
                });

            }else{
                $("#header").css("z-index","7000");
                this.$el.addClass("loaded");
                $("#pwl_overlay .loader").remove();
            }

            // metodo che gestisce il reperimento dei dati utente
            // userStatus
            // return 0; //unlogged
            // return 1; //unauthorized
            // return 2; //unsubscrived
            // return 3; //auth and sub

            //console.log("user status ------->", this.data.status);

            if(this.data.status === 1){
                $("#rest2018 div.cta.pwl_login").remove();
            }

            var linkAbb = "https://abbonamenti.corriere.it/login/?OfferId=OFF-00121177_1";
            var linkShop = "https://www.corriere.it/economia/offerta-abbonamento/?intcmp=EconomiaWall_other_290319_corriere_ss_other";
            /*var rnd_payw = Math.floor(Math.random() * 10);
           	// console.log("math random ------> ", rnd_payw);
            if( rnd_payw == 0 ){
                this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("?pwcmp=vetrinafreemium", "&pwcmp=vetrinafreemium"));
                this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("PLACEHOLDER", linkShop));
            }else{
                this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("?pwcmp=", "&pwcmp="));
                this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("PLACEHOLDER", linkAbb));
            }*/
            this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("?pwcmp=", "&pwcmp="));
            this.$el.find(".cta-placeholder").attr("href", this.$el.find(".cta-placeholder").attr("href").replace("PLACEHOLDER", linkAbb));

            __static.track("CriteoOverlay");
        },

        closeModal: function() {
            $("#pwl_overlay").fadeOut();
            this.$el.find(".close").attr("style","");
            this.$el.fadeOut();

            //custom event PwlOnClose
            __static.performMiddleware("PwlOnClose",{view:this,$el : this.$el});
        },

        show: function() {
            if(tipologia === "fotogallery") return this.fotogallery();
            var _self = this;
            if(__static.device !== "mobile") window.pwlInterval = setInterval(function(){
                if($(window).width() < 1024) return _self.$el.addClass("small-view");
                _self.$el.removeClass("small-view");
                _self.$el.css({
                    left: "",
                    "margin-left": ""
                });
            },500);
            if (this.config.showOnLoad) this.openModal();
        },

        closeVetrina: function() {
            return (this.getModalOfferta()) ? false : this.close();
        },

        close: function() {
            location.href = this.data.referrer;
            //this.closeModal(); redirigo ogni volta che non viene visualizzata la modal dell'offerta
        },

        setOffset:function($el,$scrollEl,yPos){
            if(typeof $scrollEl === "undefined" || $scrollEl.length < 1) $scrollEl = $el; //articolo lo scroll al titolo se esiste
            if(typeof yPos === "undefined") yPos = 0;
            this.$place.addClass("static-paywall");
            this.offsetScroll = $scrollEl.offset().top;
            this.offset = yPos + $el.offset().top + $el.height() + parseInt($el.css("padding-bottom")) + parseInt($el.css("padding-top"));
            this.$el.css({
                top: this.offset,
                marginTop : 0
            });
        },

        fotogallery : function(){
            var _self = this,
                openGallery = function(e){
                    e.preventDefault();
                    _self.openModal();
                    //tracciamento apertura fotogallery
                    //__static.track("PaywallOverlay")
                };

            var $gallery_ul = (__static.device == "mobile") ? $(".md_im_c2") : $(".md_im_c3");

            if($gallery_ul.find("li:not(.bx-clone)").length < 2) $(".slideshow li:not(.bx-clone)").after($(".slideshow li:not(.bx-clone)").clone());
            if(__static.device === "mobile"){
                $gallery_ul.off("touchmove").on("touchmove",function(e){
                    openGallery(e);
                });
            }else{

                try{
                    _bxMdImC3Slider.reloadSlider();
                }catch(err){
                    try{
                        setTimeout(function(){_bxMdImC3Slider.reloadSlider()},500);
                    }catch(err){}
                }

                $gallery_ul.attr("id","fotogallery_paywall").off().on("click.paywall",".bx-next, .bx-prev",function(e){
                    openGallery(e);
                });
            }
        },

        setPosition : function(){
            if($(".articolo .article-subtitle").length > 0){
                this.setOffset($(".articolo .article-subtitle"), $(".articolo .article-title"));
            } else if($(".articolo .article-title").length > 0){
                this.setOffset($(".articolo .article-title"));
            }else if(tipologia == "fotogallery" && $(".fg_title").length > 0){
                this.setOffset($(".fg_title"));
            }else{
                this.setOffset($("#header"));
            }
        },

        cases: function() {
            //posizionamento negli articoli
            if(__static.device === "mobile") return;

            this.setPosition.call(this);

            var __self = this;
            setTimeout(function(){
                if(typeof __self.countCases == "undefined") __self.countCases = 1;
                if(__self.countCases == 3) return;
                __self.cases.call(__self);
                __self.countCases++;
            },3000);
        }
    };
        var Manina = {

        name: "Manina",
        is: "manina",
        config: _ConfManine,

        el: "#pwl_ma",
        $el: $(this.el),
        $tmpl: $("#pwl_tmpl_ma"),

        setView: function() {

            if(this.data.status === 2) return "doubleOptin";

            if(__static.device === "mobile") {

                switch (this.data.credit) {
                    case 2:
                        return "MANINAXMAS2018_X";
                        break;
                    case 4:
                        return "MANINAXMAS2018_X";
                        break;
                    case 6:
                        return "MANINAXMAS2018_X";
                        break;
                    case 7:
                        return "MANINAXMAS2018_X";
                        break;
                    default:
                        return "none";
                }

            } else if(__static.device === "tablet") {

               switch (this.data.credit) {
                   case 2:
                        return "MANINAXMAS2018";
                        break;
                    case 4:
                        return "MANINAXMAS2018";
                        break;
                    case 6:
                        return "MANINAXMAS2018";
                        break;
                    case 7:
                        return "MANINAXMAS2018";
                        break;
                    default:
                        return "none";
                }

            } else{

                switch (this.data.credit) {
                    case 2:
                        return "MANINAXMAS2018";
                        break;
                    case 4:
                        return "MANINAXMAS2018";
                        break;
                    case 6:
                        return "MANINAXMAS2018";
                        break;
                    case 7:
                        return "MANINAXMAS2018";
                        break;
                    default:
                        return "none";
                }

            }

        },

        endpoint : function(){
            var __self = this;
            this.$el.find(".call-to").on("click", function(e) {
                e.preventDefault();
                if(typeof __static.vContestuale !== "undefined") return __static.vContestuale.show();
                __static.vContestuale = new __static.View(Vetrina, __static);
                __self.closeManina();
                __static.vContestuale.view = new _viewConf(__static.vContestuale.config.type[__self.view.vetrina]);
                __static.vContestuale.render();
            });
        },

        refrash : function(){
            var cd = __static.data.credit;
            __static.getData();
            this.data = __static.data;
            console.info("[PWL] - refrash manina");
            console.info("[PWL] - apw credit response -->",_apw.modules.anonymous_ac.get(),"(get by _apw.modules.anonymous_ac.get)");
            console.info("[PWL] - old credit -->",cd);
            console.info("[PWL] - new credit -->",__static.data.credit,"(get by paywall script)");
            if(__static.data.credit == cd) return this.closeManina();
            this.$el.remove();
            this.init();
            console.info("[PWL] - new Type -->",this.type);
            this.run();
            if(__static.device === "mobile") return __self.openManina();
            this.firstShow();
        },

        firstShow : function(){
            var __self = this;
            this.$el.find(".leftside").show();
            this.$el.find(".rightside").animate({width:107},1000,function(){
                __self.openManina();
            });
        },

        show: function() {
            if(_apw.modules.subscribers_ac.is_subscribed() === false) {
                manina_showed = true;
                var __self = this;
                var _offset = (__static.mobile) ? 10 : 0;


                if(__static.device === "mobile") {
                    $(window).on("scroll.paywall", function(e) {
                        if ($(this).scrollTop() <= _offset) return;

                        $(this).off("scroll.paywall");

                        __self.openManina();
                        //__self.firstShow();
                    });
                }else{
                    __self.firstShow();
                }

                //document ready
                $(function(){

                    //spostato in load
                    /*if(__static.device === "mobile") {
                        $(window).on("scroll.paywall", function(e) {
                            if ($(this).scrollTop() <= _offset) return;

                            $(this).off("scroll.paywall");

                            __self.openManina();
                            //__self.firstShow();

                        });
                    }else{
                        __self.firstShow();
                    }*/


                    __self.$el.find(".ma_logo_corriere").on("click", function(e) {
                        if(__self.$el.hasClass("closed")) return;
                        __self.closeManina();
                        return false;
                    });

                    __self.$el.on("click",".ma_logo_corriere,.ap_mobile",function(e){
                        if(!__self.$el.hasClass("closed")) return;
                        __self.openManina.call(__self);
                        return false;
                    });
                    
                    if(__static.device === "mobile")  __self.$el.find(".close").on("click",function(){
                        __self.closeManina();
                        return false;
                    });
                });

                __static.track("CriteoManina");
                if (this.endpoint) this.endpoint();
            }

            document.dispatchEvent(new CustomEvent('RCSPaywall:ManineLoaded'));
        },

        openManina: function() {
            var __self = this,
                $el = this.$el;
            (__static.device == "mobile") ?
                $el.removeClass("closed").find(".pwl_content").css("height", 140) :
                $el.removeClass("closed").find(".pwl_content").animate({
                    width : this.$el.find(".pwl_content > div").outerWidth()
                },2000,function(){
                    if(__static.device === "mobile") {
                        //custom event PwlAfterShow
                        __static.performMiddleware("PwlAfterShow",{view:__self,"$el" : $el});
                        return;
                    }
                    $el.find(".rightside").show().animate({width:107},200,function(){
                        //custom event PwlAfterShow
                        __static.performMiddleware("PwlAfterShow",{view:__self,"$el" : $el});
                    });
                }) ;

            var logged = __static.getCookie("rcsLogin");
            if(logged == '') {
                $el.find(".alreadySubscribe").show();               
            }

           /* if(__static.device == "mobile")
                $el.on("click.maninaCTA",function(e){
                    if($el.hasClass("closed")) return;
                    location.href = $el.find(".cta-offerta").attr("href");
                });*/
        },

        close: function() {
            var __self = this,
                $el = this.$el;
            (__static.device == "mobile") ?
                //$el.addClass("closed").find(".pwl_content").css("height","") :
                $el.remove() :
                $el.addClass("closed").find(".pwl_content").animate({
                    width : 0
                },800,function(){
                    //custom event intPWL
                    if(__static.device == "mobile") return __static.performMiddleware("PwlOnClose",{view:__self,"$el" : $el});

                    $el.find(".rightside").animate({
                        width : 93
                    },200,function(){
                        //custom event intPWL
                        __static.performMiddleware("PwlOnClose",{view:__self,"$el" : $el});
                    });
                });

            if(__static.device == "mobile") $el.off("click.maninaCTA");
        },

        closeManina: function() {
            this.close();
        }
    };

    /* TRACCIAMENTI */
    this.trackArray = {
	TrialOffer : function(){s.trackTrialOffer()},
	PaywallOverlay : function(){s.trackPaywallOverlay()},
	CriteoOverlay : function(){
		try{
			if(!privacyok) return __static.log("Manca flag privacy!");
	    	window.criteo_q = window.criteo_q || [];
			window.criteo_q.push(
				{ event: "setAccount", account: 18606 },
				{ event: "setSiteType", type: "d" },
				{ event: "viewSearch", nbrc: 1 },
				{ event: "viewItem", item: "wall" }
			);

			!function(f,b,e,v,n,t,s){if(f.fbq2)return;n=f.fbq2=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq2)f._fbq2=n;
			n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
			document,'script','//be-media.github.io/assets/js/fbevents2.js');

			fbq2('init', '465410580312185');
			fbq2('trackCustom', 'wall');

	    }catch(e){
	    	__static.log("Errore Tracciamento 'CriteoOverlay'");
	    }
	},
	CriteoManina : function(){
		try{
			if(!privacyok) return __static.log("Manca flag privacy!");
			function userIsLoggedIn () {
				return (function getCookie(cname) {
					var name = cname + "=";
					var ca = document.cookie.split(';');
					for(var i=0; i<ca.length; i++) {
						var c = ca[i];
						while (c.charAt(0)==' ') c = c.substring(1);
						if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
					}
					return '';
				})('apw_auth').length > 0
			}

			function getNumArticlesRed () {
				return parseInt((function getCookie(cname) {
					var name = cname + "=";
					var ca = document.cookie.split(';');
					for(var i=0; i<ca.length; i++) {
						var c = ca[i];
						while (c.charAt(0)==' ') c = c.substring(1);
						if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
					}
					return '';
				})('rcsddfglr').split('.')[2]) || 0;
			}

			var numArticlesRed = getNumArticlesRed();
            var userIsLogged = userIsLoggedIn();

			// By default, consider that user is not subscribed.
			// Get this info from _apw if user is logged in.
			var userIsSubscribed = false;
			if (userIsLogged) {
				userIsSubscribed = _apw.modules.subscribers_ac.is_subscribed();
			}

			// Track on Criteo only if numArticlesRed is greater than a threeshold
			// and if user is not subscribed yet.
			if ((numArticlesRed > 10) && (!userIsSubscribed)) {
				window.criteo_q = window.criteo_q || [];
				window.criteo_q.push(
					{ event: "setAccount", account: 18606 },
					{ event: "setSiteType", type: "d" },
					{ event: "viewSearch", nbrc: 3, nbra: numArticlesRed },
					{ event: "viewItem", item: "manina" }
				);
			}

			!function(f,b,e,v,n,t,s){if(f.fbq2)return;n=f.fbq2=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq2)f._fbq2=n;
			n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
			document,'script','//be-media.github.io/assets/js/fbevents2.js');

			fbq2('init', '465410580312185');
			var eventName = 'manina';

			var numArticlesRead = (function () {
			  return parseInt((function getCookie(cname) {
			    var name = cname + "=";
			    var ca = document.cookie.split(';');
			    for(var i=0; i<ca.length; i++) {
			        var c = ca[i];
			        while (c.charAt(0)==' ') c = c.substring(1);
			        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
			    }
			    return '';
			  })('rcsddfglr').split('.')[2]) || 0;
			})();

			var userIsLogged = (function () {
			  return (function getCookie(cname) {
			    var name = cname + "=";
			    var ca = document.cookie.split(';');
			    for(var i=0; i<ca.length; i++) {
			        var c = ca[i];
			        while (c.charAt(0)==' ') c = c.substring(1);
			        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
			    }
			    return '';
			  })('apw_auth').length > 0
			})();

			// By default, consider that user is not subscribed.
			// Get this info from _apw if user is logged in.
			var userIsSubscribed = false;
			if (userIsLogged) {
			  if (typeof _apw !== 'undefined') {
			    userIsSubscribed = _apw.modules.subscribers_ac.is_subscribed();
			  }
			}

			// Track on Facebook only if user is not subscribed yet.
			if ((!userIsSubscribed)) {
			  // Create a custom event depending on number of articles read.
			  // Aggregate in clusters 5, 10, 15, 20.
			  if (numArticlesRead <= 5) {
			    eventName += '_5';
			  } else if (numArticlesRead <= 10) {
			    eventName += '_10';
			  } else if (numArticlesRead <= 15) {
			    eventName += '_15';
			  } else if (numArticlesRead <= 20) {
			    eventName += '_20';
			  }

              fbq2('trackCustom', eventName);
			}
		}catch(e){
	    	__static.log("Errore Tracciamento 'CriteoManina'");
	    }
	},
	CriteoOffertaFreeTrial : function(){
		try{
			if(!privacyok) return __static.log("Manca flag privacy!");
		  	window.criteo_q = window.criteo_q || [];
			window.criteo_q.push(
				{ event: "setAccount", account: 18606 },
				{ event: "setSiteType", type: "d" },
				{ event: "viewSearch", nbrc: 2 },
				{ event: "viewItem", item: "trial" }
			);
			!function(f,b,e,v,n,t,s){if(f.fbq2)return;n=f.fbq2=function(){n.callMethod?
			n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq2)f._fbq2=n;
			n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
			t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
			document,'script','//be-media.github.io/assets/js/fbevents2.js');

			fbq2('init', '465410580312185');
			fbq2('trackCustom', 'trial');
		}catch(e){
	    	__static.log("Errore Tracciamento 'CriteoManina'");
	    }
	}
}

this.track = function(_key, _params){
	if(_key in this.trackArray){
		this.trackArray[_key].call(this,_params);
		return;
	}
	return __static.log("Tipologia di tracciamento "+_key+" non trovata");
}

//metodo per i tracciamenti
this.trackoverlay = function(){
	return (this.isAnteprima() && tipologia != "fotogallery")
}

    /* MIDDLEWARE MANAGER */
    //lista dei custom event
this.Middlewares = {
	eventList : [
		"PwlInitDone", 		//Invocato subito dopo l'init di PWL
		"PwlViewInit",		//Invocato subito dopo la init della view
		"PwlRunDone",		//Invocato subito dopo la run di PWL (selezione view)
		"PwlBeforeShow",	//Invocato subito prima che venga mostrata la view (dopo il render dell'elemento)
		"PwlAfterShow",		//Invocato subito dopo aver mostrato la view
		"PwlOnClose",		//Invocato subito durante la chiusura della view
		"PwlOnOffertShow",	//Invocato subito durante l'apertura dell'offerta
		"PwlOnOffertClose"	//Invocato subito durante la chiusura dell'offerta
	]
};

//richiamo di un custom event
this.performMiddleware = function(_event,_data){

	if(typeof _data === "undefined") _data = {};

	_data = $.extend({
		pwl : __static,
		time: new Date()
    },_data);
    
    if(_event == 'PwlAfterShow') {
		var Event = document.createEvent('CustomEvent'); 
		Event.initCustomEvent('PwlAfterShow_new', true, true);
		document.dispatchEvent(Event);
	}

	$(document).trigger(_event,_data);
}

    this.init();

}

var PWL_methAnt = 0;
var paywall = new __PWL();
paywall.run();
if (typeof paywall.view !== 'undefined' ){
    paywall.view.run();
}